var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { PrintCompanyInfo } from './print-company-info';
import { PrintIntegration } from './print-integration-info';
import { PrintOwner } from './print-owners-info';
import { PrintProcessing } from './print-processing-info';
import { PrintWebsites } from './print-website-info';
var ComponentToPrint = /** @class */ (function (_super) {
    __extends(ComponentToPrint, _super);
    function ComponentToPrint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ComponentToPrint.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsxs("div", { children: [_jsx("h3", { children: "Company Information" }), _jsx(PrintCompanyInfo, { companyInfo: this.props.formWizard.companyInfo }), _jsx("h3", { children: "Websites" }), _jsx(PrintWebsites, { websites: this.props.formWizard.websites }), _jsx("h3", { children: "Directors and Owners" }), _jsx(PrintOwner, { owners: this.props.formWizard.owners }), _jsx("h3", { children: "Processing" }), _jsx(PrintProcessing, { processing: this.props.formWizard.processing }), _jsx("h3", { children: "Integration" }), _jsx(PrintIntegration, { integration: this.props.formWizard.integration })] }));
        }
    });
    return ComponentToPrint;
}(React.PureComponent));
export { ComponentToPrint };
